import React from "react";
import PropTypes from "prop-types";

import { clx } from "../../utils/Helpers";
import { CLIENT_PROFILE_EMPTY_VALUE } from "./clientProfileHelpers";

function ClientProfileField({ label, value, valueClassName }) {
  return (
    <div className="company-portal-profile-field">
      <div className="company-portal-profile-field__label">{label}</div>
      <div
        className={clx("company-portal-profile-field__value", valueClassName)}
      >
        {value ?? CLIENT_PROFILE_EMPTY_VALUE}
      </div>
    </div>
  );
}

ClientProfileField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  valueClassName: PropTypes.string,
};

ClientProfileField.defaultProps = {
  value: undefined,
  valueClassName: undefined,
};

export default ClientProfileField;
